import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { isNil } from 'lodash'
import { EVENT_TYPES_CODES } from '../../../events/constants/EventsConstants'
import RpqsAction from '../../actions/RpqsAction'
import RpqsEventsList from './RpqsEventsList'

// Événements de la fiche d'une collectivité (collectivityId) ou d'une entité de gestion (managementUnitId).
const RpqsReferentialEventsApp = ({
    collectivityId,
    managementUnitId,
}) => {
    const dispatch = useDispatch()
    const [events, setEvents] = useState([])

    const collectivity = isNil(collectivityId) ? undefined : parseInt(collectivityId)
    const managementUnit = isNil(managementUnitId) ? undefined : parseInt(managementUnitId)

    const refreshEvents = useCallback(() => {
        const fetch = isNil(managementUnit) ? RpqsAction.fetchCollectivityEvents(collectivity) : RpqsAction.fetchManagementUnitEvents(managementUnit)
        dispatch(fetch).then(res => setEvents(res ?? []))
    }, [dispatch, collectivity, managementUnit])

    useEffect(() => {
        refreshEvents()
    }, [refreshEvents])

    const newEvent = useMemo(() => ({
        collectivityId: collectivity,
        managementUnitId: managementUnit,
        eventType: EVENT_TYPES_CODES.COMMENT,
    }), [collectivity, managementUnit])

    const onSave = event => {
        const action = isNil(event.number) ? RpqsAction.createReferentialEvent : RpqsAction.updateReferentialEvent
        return dispatch(action(event)).then(json => {
            if (json?.insert || json?.update) refreshEvents()
            return json
        })
    }

    const onDelete = event => dispatch(RpqsAction.deleteReferentialEvent(event)).then(json => {
        if (json?.delete) refreshEvents()
        return json
    })

    return (
        <RpqsEventsList
            events={events}
            newEvent={newEvent}
            onSave={onSave}
            onDelete={onDelete}
        />
    )
}

RpqsReferentialEventsApp.propTypes = {
    collectivityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    managementUnitId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default RpqsReferentialEventsApp
